import { StringParam, useQueryParam, withDefault } from 'use-query-params';
import Select from '../../../components/input/select/Select';
import { QueryParamNames } from '../enums/QueryParamNames';
import SortDirectionButton from '../../../components/input/buttons/sortDirection/SortDirectionButton';
import type { SortDirection } from '@gdladder/shared/enums';
import { LevelSortType } from '@gdladder/shared/features';

const sorts = {
    [LevelSortType.LEVEL_ID]: 'Level ID',
    [LevelSortType.NAME]: 'Name',
    [LevelSortType.RATING]: 'Rating',
    [LevelSortType.ENJOYMENT]: 'Enjoyment',
    [LevelSortType.RATING_COUNT]: 'Rating count',
    [LevelSortType.ENJOYMENT_COUNT]: 'Enjoyment count',
    [LevelSortType.DEVIATION]: 'Deviation',
    [LevelSortType.POPULARITY]: 'Popularity',
    [LevelSortType.DENSITY]: 'Density',
    [LevelSortType.OBJECT_COUNT]: 'Object count',
    [LevelSortType.SECONDS]: 'Duration',
};
type Sorts = keyof typeof sorts;

export default function SortMenu() {
    const [sorter, setSorter] = useQueryParam('sort', withDefault(StringParam, 'ID'));
    const [sortDirection, setSortDirection] = useQueryParam(
        QueryParamNames.SORT_DIRECTION,
        withDefault(StringParam, 'asc'),
    );

    const handleSortDirectionChange = (dir: SortDirection) => {
        try {
            const filters = JSON.parse(sessionStorage.getItem('level-filters') ?? '{}') as object;
            sessionStorage.setItem('level-filters', JSON.stringify({ ...filters, sortDirection: dir }));
            setSortDirection(dir);
        } catch (error) {
            console.error(error);
        }
    };

    const handleSorterChange = (sortBy: string) => {
        try {
            const filters = JSON.parse(sessionStorage.getItem('level-filters') ?? '{}') as object;
            sessionStorage.setItem('level-filters', JSON.stringify({ ...filters, sort: sortBy }));
            setSorter(sortBy);
        } catch (error) {
            console.error(error);
        }
    };

    const sanitizedSorter: Sorts = Object.keys(sorts).includes(sorter) ? (sorter as Sorts) : LevelSortType.LEVEL_ID;

    return (
        <div className='max-md:grow flex items-center mt-4 gap-2'>
            <Select label={`Sort by: ${sorts[sanitizedSorter]}`} options={sorts} onOption={handleSorterChange} />
            <SortDirectionButton direction={sortDirection} onChange={handleSortDirectionChange} />
        </div>
    );
}
